
export { V2FTMigrationInitFlow } from "/home/runner/work/capsicum/capsicum/libs/features/nc-wallet/web/src/feature/index.ts"